<template>
  <div>
    <a-card class="m-bottom">
      <template slot="title">
        <span><a-icon type="project"></a-icon> Rekap Beban Cost Center</span>
      </template>
      <ul class="list-wrapper bordered">
        <li>
          <span class="list-title" for>Periode</span>
          <span class="list-desc">{{
            data.header[0].awal_periode + " - " + data.header[0].akhir_periode
          }}</span>
        </li>
        <li>
          <span class="list-title" for>Description</span>
          <span class="list-desc">{{ data.header[0].description }}</span>
        </li>
      </ul>
    </a-card>
    <a-card>
      <template slot="title">
        <span>Daftar Rekap</span>
      </template>
      <template slot="extra"
        ><a-input-search
          v-model="search"
          placeholder="search here"
        ></a-input-search
      ></template>
      <a-table bordered :columns="columns" :data-source="datarekap">
        <template slot="value" slot-scope="record, item">
          <span>{{ formatCurrency("", item.value) }}</span>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "manifest-cost-center",
  mixins: [CurrencyFormat],
  data() {
    const columns = [
      {
        title: "Cost Center",
        key: "cost_center",
        dataIndex: "kode_project"
      },
      {
        title: "value",
        scopedSlots: { customRender: "value" },
        key: "value"
      }
    ];
    return {
      data: {},
      columns,
      search: ""
    };
  },
  computed: {
    datarekap() {
      let output = this.data.detail;

      if (this.search) {
        output = this.data.detail.filter(
          item =>
            item.kode_project
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            item.value.indexOf(this.search) >= 0
        );
      }

      return output;
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.$store.dispatch("getManifest", { id: this.$attrs.id }).then(res => {
        this.data = res;
      });
    }
  }
};
</script>

<style></style>
